import React, { useState, useEffect } from 'react';
import {
  Divider, Form, Input, Select, Collapse, notification, Spin,
} from 'antd';
import Cookies from 'js-cookie';
import { get, isEmpty } from 'lodash';
import getFormItemRules from '../../shared/form-helper';
import TestCampaign from '../test-campaign';
import HTMLEditor from '../../utils/jodit-react-component';
import API from '../../utils/Api';

const { Option } = Select;
const { Panel } = Collapse;

const EmailCompaign = (properties) => {
  const { form, next, selectCampaign } = properties;
  const myApi = new API({});
  myApi.createEntity({ name: 'campaign' });
  const [apiUrl] = useState(Cookies.get('apiUrl'));
  const [loading, setLoading] = useState(false);
  const [mailData, setmailData] = useState([]);

  const fetchData = () => {
    setLoading(true);
    const params = {
      apiUrl,
    };
    myApi.endpoints.campaign.create(params, {}, 'get-tenant').then((response) => {
      const data = get(response, 'data.data', []);
      setmailData(data);
      setLoading(false);
    }).catch((err) => {
      notification.error({ message: err || 'failed to load the data' });
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Spin spinning={loading}>
      <Collapse defaultActiveKey={['1']}>
        <Panel header="Email Details" key="1">
          <Form.Item
            label="Subject"
            name="subject"
            rules={[
              ...getFormItemRules({
                required: true,
              }),
            ]}
          >
            <Input style={{ width: '650px' }} />
          </Form.Item>
          <div className="grid-auto-3">
            <Form.Item
              label="Sender Name"
              name="sender_name"
              rules={[
                ...getFormItemRules({
                  required: true,
                }),
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="From email address"
              name="from_email_address"
              rules={[
                ...getFormItemRules({
                  required: true,
                }),
              ]}
            >
              <Select>
                {!isEmpty(mailData) && mailData.map((item) => <Option value={item.from_email_address}>{item.from_email_address}</Option>)}
              </Select>
            </Form.Item>
            <Form.Item
              label="Reply-to email address"
              name="reply_to_email_address"
              rules={[
                ...getFormItemRules({
                  required: true,
                }),
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </div>
        </Panel>
      </Collapse>
      <Form.Item
        label="Email Template Content"
        name="email_template_content"
        initialValue=""
        rules={[
          ...getFormItemRules({
            required: true,
          }),
        ]}
      >
        <HTMLEditor
          config={{ minHeight: 400, width: 1200 }}
        />
      </Form.Item>
      <Divider />
      <TestCampaign form={form} next={next} selectCampaign={selectCampaign} />
    </Spin>
  );
};

export default EmailCompaign;
